export default function createImg(src, onClick) {
  const img = document.createElement('img');
  img.setAttribute('src', src);
  img.classList.add('icon');
  img.addEventListener('click', onClick);
  return img;
}
